"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keyMirror2 = _interopRequireDefault(require("react-utils/keyMirror"));

var _ContactRoleTypes = require("customer-data-objects/contact/ContactRoleTypes");

var _CompanyRoleTypes = require("customer-data-objects/company/CompanyRoleTypes");

var _keyMirror;

var _default = (0, _keyMirror2.default)((_keyMirror = {
  DEAL_TO_LINE_ITEM: null,
  TICKET_TO_CONTACT: null,
  TICKET_TO_COMPANY: null,
  TICKET_TO_FEEDBACK_SUBMISSION: null,
  CONTACT_TO_TICKET: null,
  COMPANY_TO_TICKET: null,
  CONTACT_TO_DEAL: null,
  COMPANY_TO_DEAL: null,
  DEAL_TO_COMPANY: null,
  DEAL_TO_CONTACT: null,
  TICKET_TO_DEAL: null,
  DEAL_TO_QUOTE: null,
  DEAL_TO_TICKET: null,
  COMPANY_TO_CONTACT: null,
  CONTACT_TO_COMPANY: null,
  CONTACT_TO_ENGAGEMENT: null,
  CONTACT_TO_FEEDBACK_SUBMISSION: null,
  ENGAGEMENT_TO_COMPANY: null,
  ENGAGEMENT_TO_CONTACT: null,
  ENGAGEMENT_TO_DEAL: null,
  ENGAGEMENT_TO_TICKET: null,
  FEEDBACK_SUBMISSION_TO_CONTACT: null,
  FEEDBACK_SUBMISSION_TO_TICKET: null,
  CONVERSATION_TO_DEAL: null,
  CONVERSATION_TO_TICKET: null,
  CONTACT_TO_QUOTE: null,
  QUOTE_TO_CONTACT: null,
  QUOTE_TO_COMPANY: null,
  COMPANY_TO_QUOTE: null
}, (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.ADVISOR_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_ADVISOR, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.BOARD_MEMBER_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_BOARD_MEMBER, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.CONTRACTOR_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_CONTRACTOR, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.MANAGER_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_MANAGER, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.OWNER_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_OWNER, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.PARTNER_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_PARTNER, null), (0, _defineProperty2.default)(_keyMirror, _ContactRoleTypes.RESELLER_TO_COMPANY, null), (0, _defineProperty2.default)(_keyMirror, _CompanyRoleTypes.COMPANY_TO_RESELLER, null), _keyMirror));

exports.default = _default;
module.exports = exports.default;